var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageEditorText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H6.66667V16H4V18H11.3333V16H8.66667V2H13.3333V4H15.3333V1C15.3333 0.734784 15.228 0.480429 15.0404 0.292893C14.8529 0.105357 14.5985 0 14.3333 0H1C0.734783 0 0.480429 0.105357 0.292893 0.292893C0.105357 0.480429 0 0.734784 0 1V4H2V2Z",
    fill: "#FB4764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 7V9.66667H12.3335V11.6667H15.0002V15C15.0002 15.7956 15.3162 16.5587 15.8788 17.1213C16.4415 17.6839 17.2045 18 18.0002 18H20.0002V16H18.0002C17.7349 16 17.4806 15.8946 17.2931 15.7071C17.1055 15.5196 17.0002 15.2652 17.0002 15V11.6667H19.6668V9.66667H17.0002V7H15.0002Z",
    fill: "#FB4764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageEditorText);
export default __webpack_public_path__ + "static/media/ImageEditorText.070b7abdc2d6fbb032e890aef859111e.svg";
export { ForwardRef as ReactComponent };